(function () {
  function initReveal(root) {
    const sections = root.querySelectorAll("[data-s26hp-reveal]");

    if (!sections.length) {
      return;
    }

    const revealImmediately = !("IntersectionObserver" in window);

    if (revealImmediately) {
      sections.forEach(function (section) {
        section.classList.add("is-visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.12
      }
    );

    sections.forEach(function (section) {
      if (section.closest(".s26hp--animations-off")) {
        section.classList.add("is-visible");
        return;
      }

      observer.observe(section);
    });
  }

  function initCarousel(root) {
    const carousels = root.querySelectorAll(".s26hp__carousel");

    carousels.forEach(function (carousel) {
      if (carousel.dataset.s26hpCarouselReady === "true") {
        return;
      }

      const viewport = carousel.querySelector("[data-s26hp-carousel-viewport]");
      const track = carousel.querySelector("[data-s26hp-carousel]");
      const slides = Array.from(carousel.querySelectorAll("[data-s26hp-carousel-slide]"));
      const prev = carousel.querySelector("[data-s26hp-carousel-prev]");
      const next = carousel.querySelector("[data-s26hp-carousel-next]");
      const dots = Array.from(carousel.querySelectorAll("[data-s26hp-carousel-dot]"));
      const dotsWrap = carousel.parentElement && carousel.parentElement.querySelector("[data-s26hp-carousel-dots]");

      if (!viewport || !track || !slides.length) {
        return;
      }

      carousel.dataset.s26hpCarouselReady = "true";

      const getStep = function () {
        const firstSlide = slides[0];
        const styles = window.getComputedStyle(track);
        const rawGap = styles.columnGap || styles.gap || "0";
        const parsedGap = parseFloat(rawGap);
        const gap = Number.isNaN(parsedGap) ? 0 : parsedGap;
        return firstSlide.getBoundingClientRect().width + gap;
      };

      const getActiveIndex = function () {
        const step = getStep();

        if (!step) {
          return 0;
        }

        return Math.max(0, Math.round(viewport.scrollLeft / step));
      };

      const updateDots = function () {
        if (!dots.length) {
          return;
        }

        const activeIndex = getActiveIndex();
        dots.forEach(function (dot, index) {
          dot.classList.toggle("is-active", index === activeIndex);
        });
      };

      const syncOverflow = function () {
        const isOverflowing = viewport.scrollWidth - viewport.clientWidth > 4;
        carousel.classList.toggle("is-overflowing", isOverflowing);

        if (prev) {
          prev.hidden = !isOverflowing;
        }

        if (next) {
          next.hidden = !isOverflowing;
        }

        if (dotsWrap) {
          dotsWrap.hidden = !isOverflowing || dots.length <= 1;
        }
      };

      const goTo = function (index) {
        const step = getStep();
        viewport.scrollTo({
          left: step * index,
          behavior: "smooth"
        });
      };

      const move = function (direction) {
        const activeIndex = getActiveIndex();
        const nextIndex = activeIndex + direction;
        const maxIndex = slides.length - 1;

        if (nextIndex > maxIndex) {
          goTo(0);
          return;
        }

        if (nextIndex < 0) {
          goTo(maxIndex);
          return;
        }

        goTo(nextIndex);
      };

      if (prev) {
        prev.addEventListener("click", function () {
          move(-1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          move(1);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () {
          goTo(index);
        });
      });

      viewport.addEventListener("scroll", function () {
        window.requestAnimationFrame(updateDots);
      }, { passive: true });

      window.addEventListener("resize", function () {
        window.requestAnimationFrame(syncOverflow);
        window.requestAnimationFrame(updateDots);
      });

      if (carousel.dataset.s26hpAutoplay === "true") {
        const delay = parseInt(carousel.dataset.s26hpAutoplaySpeed, 10) || 5000;
        let timer = window.setInterval(function () {
          move(1);
        }, delay);

        carousel.addEventListener("mouseenter", function () {
          window.clearInterval(timer);
        });

        carousel.addEventListener("mouseleave", function () {
          timer = window.setInterval(function () {
            move(1);
          }, delay);
        });
      }

      syncOverflow();
      updateDots();
    });
  }

  function init(root) {
    initReveal(root || document);
    initCarousel(root || document);
  }

  init(document);

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
